module.exports = __webpack_public_path__ + "img/banner7.ccbb534a.jpg";